import { render, staticRenderFns } from "./DashboardSummary.vue?vue&type=template&id=ff92e74c&scoped=true"
import script from "./DashboardSummary.vue?vue&type=script&lang=js"
export * from "./DashboardSummary.vue?vue&type=script&lang=js"
import style0 from "./DashboardSummary.vue?vue&type=style&index=0&id=ff92e74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff92e74c",
  null
  
)

export default component.exports